import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import CarsonLogo from '../../res/svg/CarsonLogoS.svg';
import { history } from '../../store';

const LogoComponent = () => {
  const { t } = useTransl();
  const openHomePage = () => history.push('/');

  return (
    <Box
      sx={{
        mb: '3rem',
        width: '50%',
      }}
      onClick={openHomePage}
      onKeyPress={openHomePage}
      role="button"
      tabIndex="0"
    >
      <img
        style={{ width: '100%' }}
        src={CarsonLogo}
        alt={t('altLabel.carsonLogo')}
      />
    </Box>
  );
};

export default LogoComponent;
